export default __webpack_public_path__ + "static/media/me6.efd184c3.svg";